"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDataTapes = void 0;
const consts_1 = require("../consts");
const utils = __importStar(require("../dbNodes/utils"));
const typeguards = __importStar(require("../typeguards"));
const validateGeneratedRepaymentTapes_1 = require("./validateGeneratedRepaymentTapes");
const validateOrgProvidedInputNodes = (dataTapes) => {
    const errorMessages = [];
    // validate org provided inputs
    const orgProvidedKeySet = new Set();
    const orgProvidedInputNodes = dataTapes.filter((dt) => dt.type === 'orgProvidedInput');
    for (const node of orgProvidedInputNodes) {
        const key = node.configuration.orgProvidedKey;
        if (orgProvidedKeySet.has(key)) {
            errorMessages.push(`orgProvidedInput: [${node.artifactSlug}] has duplicate org provided key [${key}]`);
        }
        else {
            orgProvidedKeySet.add(key);
        }
    }
    return errorMessages;
};
const validateDataTapes = ({ dataTapeDependencies, dataTapes, }) => {
    const loanTapeTypeMap = utils.generateLoanTapeTypeMap(dataTapes);
    const errorMessages = [];
    // validate generated repayment tape
    const generatedRepaymentResults = (0, validateGeneratedRepaymentTapes_1.validateGeneratedRepaymentTapeNodes)({
        dataTapes,
        loanTapeTypeMap,
    });
    generatedRepaymentResults.errors.forEach((err) => errorMessages.push(err));
    // validate org provided inputs
    errorMessages.push(...validateOrgProvidedInputNodes(dataTapes));
    // ensure that there are no duplicate uuids in dataTapes
    const dataTapeIds = dataTapes.map(({ id }) => id);
    const uniqueDataTapeIds = new Set(dataTapeIds);
    if (dataTapeIds.length !== uniqueDataTapeIds.size) {
        errorMessages.push('Duplicate ids in dataTapes');
    }
    // ensure that dataTapeDependencies reference valid dataTapes
    dataTapeDependencies.forEach(({ inputArtifactId, outputArtifactId }) => {
        const inputTape = dataTapes.find((tape) => tape.id === inputArtifactId);
        const outputTape = dataTapes.find((tape) => tape.id === outputArtifactId);
        if (!inputTape) {
            errorMessages.push(`Invalid inputArtifactId: ${inputArtifactId}`);
        }
        if (!outputTape) {
            errorMessages.push(`Invalid outputArtifactId: ${outputArtifactId}`);
        }
    });
    // for a given tape id, find all the tapes that depend on it
    const getOutputTapes = (tapeId) => {
        return dataTapeDependencies.filter(({ inputArtifactId }) => inputArtifactId === tapeId);
    };
    // for a given tape id, find all the tapes that it depends on
    const getInputTapes = (tapeId) => {
        return dataTapeDependencies.filter(({ outputArtifactId }) => outputArtifactId === tapeId);
    };
    const rawTapes = dataTapes.filter((tape) => (0, consts_1.isRawTapeType)(tape.type));
    const derivedTapes = dataTapes.filter((tape) => (0, consts_1.isDerivedTapeType)(tape.type));
    // raw tapes
    rawTapes.forEach((tape) => {
        // they must not depend on other tapes.
        if (getInputTapes(tape.id).length) {
            errorMessages.push(`Raw tape ${tape.artifactSlug} depends on other tapes`);
        }
        // they must be depended on by at least one tape.
        if (getOutputTapes(tape.id).length === 0) {
            errorMessages.push(`Raw tape ${tape.artifactSlug} is not depended on`);
        }
    });
    // derived Tapes
    derivedTapes.forEach((tape) => {
        // must depend on at least one tape.
        if (getInputTapes(tape.id).length === 0) {
            errorMessages.push(`Derived tape ${tape.artifactSlug} does not depend on any tapes`);
        }
    });
    // validate that dataTapes can be converted into tapeBuilderRecords
    dataTapes.forEach((tape) => {
        // strip out timestamps before validating.
        const result = typeguards.validateTapeBuilderRecordUI(tape);
        if (!result.isValid) {
            errorMessages.push(`[${tape.artifactSlug}] is invalid type: ${result.errorMessages.join(', ')}`);
        }
    });
    return {
        isValid: errorMessages.length === 0,
        errorMessages,
    };
};
exports.validateDataTapes = validateDataTapes;
//# sourceMappingURL=validateDataTapes.js.map